import { Component, OnInit, Input } from '@angular/core';
import { EstacionesTVADB } from 'src/app/DAO/EstacionesTVADB';
import { MasterDB } from 'src/app/DAO/MasterDB';

@Component({
  selector: 'app-pregunta',
  templateUrl: './pregunta.component.html',
  styleUrls: ['./pregunta.component.css']
})
export class PreguntaComponent implements OnInit {
  @Input() pregunta;
  @Input() db;
  @Input() global;

  uploadEvidencia() {
    alert('Evidencia cargada');
  };
  constructor() { }

  ngOnInit() {
    this.global.IdPregunta = this.pregunta.IdPregunta;
  }

  inputClick(respuesta) {
    if (respuesta.flagHasRule) {

    }
    var data: any = {
      IdRelacion: respuesta.IdRelacion,
      IdRespuesta: respuesta.IdRespuesta,
      IdPregunta: respuesta.IdPregunta,
      IdRubro: this.global.idRubro,
      IdBloque: this.global.idBloque,
      IdChecklist: this.global.idChecklist,
      IdRevision: this.global.idRevision,
      IdEmpleadoContesta: this.global.idEmpleadoSesion,
      Calificacion: respuesta.Ponderacion,
      Texto: null,
      FechaMod: new Date().toUTCString(),
      FechaSync: respuesta.FechaSync
    };
    if (false) {
      data.Texto = respuesta.Texto;
    }
    MasterDB.postRespuesta(data, new EstacionesTVADB());
  }
}
